export const PLATFORM_AUDIT_ACTIONS = [
  'platform.church.suspended',
  'platform.church.reactivated',
  'platform.church.payments_suspended',
  'platform.church.payments_resumed',
  'platform.subscription.updated',
  'platform.user.updated',
  'platform.email.route_updated',
  'platform.sms.transport_updated',
  'platform.giving_payments.providers_updated',
  'platform.app_version.updated',
  'platform.console_session.updated',
  'platform.content_default_images.updated',
  'platform.impersonation.started',
  'platform.impersonation.ended',
  'platform.support_ticket.created',
  'platform.support_ticket.replied',
  'platform.support_ticket.assigned',
  'platform.support_ticket.escalated',
  'platform.support_ticket.resolved',
  'platform.support_ticket.closed',
  'platform.support_ticket.visit_linked',
  'platform.job.dead_letter_resolved',
  'platform.job.dead_letter_retried',
  'platform.coupon.created',
  'platform.coupon.updated',
] as const;

export type PlatformAuditAction = (typeof PLATFORM_AUDIT_ACTIONS)[number];
